const messages = {
  title: "Maintenance work",
  description: "Necessary maintenance work is currently being carried out on the servers." +
      "<br/><br/>As a result, access to <b>BRIDGESTONE <span class=\"text-danger\">PLUS</span></b> " +
      "is currently unavailable to you.<br/><br/>We thank you for your patience and understanding." +
      "<br/><br/> Your Bridgestone team"
}
export default {
    messages
}
